import { render, staticRenderFns } from "./feedbackdash.vue?vue&type=template&id=37fcb1ba&scoped=true"
import script from "./feedbackdash.vue?vue&type=script&lang=js"
export * from "./feedbackdash.vue?vue&type=script&lang=js"
import style0 from "./feedbackdash.vue?vue&type=style&index=0&id=37fcb1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcb1ba",
  null
  
)

export default component.exports